// removed by extract-text-webpack-plugin
module.exports = {"header":"_2SCYy1YXiKWkxu-EM21Wyl","content-container":"_2CDzb7yGarNZ9y6tTgOsia","image-container":"_1xsr28FQsTSR27AaTZkmHL","content":"_23_IacIMXMNHsk6t-gA3wx","button-container":"_11t4C4oLHSsFJzE4pS4Fdd","mobile-link":"_3mnkzc9fItNFWjH9XNb5Hk","ios-link":"_1KIiGoJeCWZeCBYoTmfPrQ _3mnkzc9fItNFWjH9XNb5Hk","android-link":"_19oiLl2uRbRR_I2-er1ykf _3mnkzc9fItNFWjH9XNb5Hk","text-link":"_3riHRykIWA2X3TZgbkHevy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileApp/MobileApp.scss
// module id = 1194
// module chunks = 47